import React, { Fragment } from "react";
import { WorkplaceTypes } from "../../Workplaces/AddWorkplace/AddWorkplaceButton/AddWorkplaceButton";

import { Button } from "../Button/Button";
import { DeleteButton } from "../DeleteButton/DeleteButton";
import { InformationBox } from "../InformationBox/InformationBox";

import "./ResourceActions.scss";

interface Props {
  message: string;
  onDelete: () => void;
  type?: WorkplaceTypes;
  isWorkplaceSection?: boolean;
  onTemplateClick?: () => void;
  onMoveClick?: () => void;
}

export const ResourceActions = (props: Props) => {
  const { message, type, onTemplateClick, onMoveClick, isWorkplaceSection } =
    props;
  const hasTemplateAction = ["Desk", "Room"].includes(type as WorkplaceTypes);
  const hasMoveAction =
    !!isWorkplaceSection &&
    ["Desk", "Room", "Wayfinder"].includes(type as WorkplaceTypes);
  const deleteTooltip = type
    ? `Delete ${String(type).toLowerCase()}`
    : "Delete resource";

  const actionItems: { key: string; node: React.ReactNode }[] = [
    {
      key: "info",
      node: <InformationBox message={message} />,
    },
  ];

  if (hasTemplateAction) {
    actionItems.push({
      key: "template",
      node: (
        <Button
          color="simple"
          iconOnly
          className="ResourceActions__template Button--icon-plain Button--icon-action"
          tooltip={type === "Room" ? "Room template" : "Desk template"}
          icon={
            type === "Room"
              ? "room_template_icon_18x18"
              : "desk_template_icon_18x18"
          }
          onClick={() => {
            if (onTemplateClick) {
              onTemplateClick();
            }
          }}
        />
      ),
    });
  }

  if (hasMoveAction) {
    actionItems.push({
      key: "move",
      node: (
        <Button
          color="simple"
          iconOnly
          icon="move-icon"
          tooltip="Move resource"
          onClick={onMoveClick}
          className="ResourceActions__move Button--icon-plain Button--icon-action"
        />
      ),
    });
  }

  actionItems.push({
    key: "delete",
    node: (
      <DeleteButton
        onClick={props.onDelete}
        tooltip={deleteTooltip}
        className="ResourceActions__delete Button--icon-action"
      />
    ),
  });

  return (
    <div className="ResourceActions d-flex align-items-center">
      {actionItems.map(({ key, node }, index) => (
        <Fragment key={key}>
          {index > 0 && (
            <>
              <span className="ResourceActions__gap" />
              <span className="ResourceActions__separator" />
              <span className="ResourceActions__gap" />
            </>
          )}
          {node}
        </Fragment>
      ))}
    </div>
  );
};
